<app-navbar [showReservationSearch]="false" [title]="title()">
	<div class="d-flex justify-content-center align-items-center">
		<app-translation-language-select
			[enabledLanguages]="languagesSupported"
			(onLanguageChange)="changeLanguage($event)"
		></app-translation-language-select>
		<mat-form-field appearance="fill">
			<mat-label>{{ 'currency.currency' | translate }}</mat-label>
			<mat-select [(ngModel)]="currency">
				<!--		business-side wants specifically these two currencies, so instead of listing options from ERPCurrency enum, I'm just hand-adding them		-->
				<mat-option value="pln">{{ 'currency.currencies.zloty' | translate }}</mat-option>
				<mat-option value="eur">{{ 'currency.currencies.euro' | translate }}</mat-option>
			</mat-select>
		</mat-form-field>
		<button mat-fab extended="1" (click)="print()">
			<i class="fas fa-print"></i>
			Drukuj
		</button>
	</div>
</app-navbar>

@if (!expiredDocumentExists) {
	<div class="container container-1">
		<div class="row">
			<div class="col-8 offset-2 text-center text-decoration-underline mb-3">
				<h1>{{ 'eventBusiness.eventBusinessIssues.vindication.noExpiredPayments' | translate }}</h1>
			</div>
		</div>
	</div>
} @else {
	<div class="container container-1">
		<div class="row">
			<div class="col-10 offset-1 text-center mb-3">
				<p>{{ 'eventBusiness.eventBusinessIssues.vindication.notice' | translate }}</p>
			</div>
		</div>
		<div class="row col-10 offset-1 mb-3">
			<table class="table table-bordered">
				<tr>
					<td class="text-center">
						{{ 'eventBusiness.eventBusinessIssues.vindication.table.document' | translate }}
					</td>
					<td class="text-center">
						{{ 'eventBusiness.eventBusinessIssues.vindication.table.issueDate' | translate }}
					</td>
					<td class="text-center">
						{{ 'eventBusiness.eventBusinessIssues.vindication.table.invoiceAmount' | translate }}
					</td>
					<td class="text-center">
						{{ 'eventBusiness.eventBusinessIssues.vindication.table.daysDue' | translate }}
					</td>
					<td class="text-center">
						{{ 'eventBusiness.eventBusinessIssues.vindication.table.invoiceDate' | translate }}
					</td>
					<td class="text-center">
						{{ 'eventBusiness.eventBusinessIssues.vindication.table.leftToPay' | translate }}
					</td>
				</tr>
				@for (item of issued; track item.id) {
					<tr>
						<td class="text-center">{{ item.documentNumber }}</td>
						<td class="text-center">{{ item.date }}</td>
						<td class="text-center">{{ item.value }} {{ item.currency.toUpperCase() }}</td>
						<td class="text-center">
							{{
								'eventBusiness.eventBusinessIssues.vindication.daysLeft'
									| translate: { value: getGetExpiredDaysCountForIssue(item) }
							}}
						</td>
						<td class="text-center">{{ item.due }}</td>
						<th class="text-center">{{ item.settled }} {{ item.currency.toUpperCase() }}</th>
					</tr>
				}
			</table>
		</div>
	</div>
}
